import { Alert, AlertTitle, Link } from "@mui/material";
import {
  getResourcePath,
  Resources,
  useResource,
} from "Translations/Resources";
import { Trans } from "react-i18next";

const RESOURCES = Resources.Beta.AuthCard;

export const BetaInfoCard = () => {
  const { t } = useResource();

  return (
    <Alert severity="info" icon={false} sx={{ fontSize: "0.875rem" }}>
      <AlertTitle>{t(RESOURCES.Title)}</AlertTitle>
      <Trans
        i18nKey={getResourcePath(RESOURCES.Body)}
        components={{
          roadmap: (
            <Link
              href={t(Resources.Beta.RoadmapUrl)}
              target="_blank"
              rel="noopener"
            />
          ),
        }}
      />
    </Alert>
  );
};
